export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "greenlotto-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "greenlotto-themeWrapLive" */'./LiveThemeImporter'),
  },
};
